import { useState } from 'react';
import './PartyPackageCard.css';
import { IoLocationSharp } from "react-icons/io5";
import { FaRegStar } from "react-icons/fa6";
import { API_BASE_URL } from '../utils';
import defaultImage from '../Assets/partyimage1.jpg';
import { RiCheckboxBlankCircleFill  } from "react-icons/ri";

const PartyPackageCard = ({ data, setSelectedCard, isSelected, isListingPage, isVenueList, isTablebids, isbiding, latitude, longitude }) => {

    const url = `${API_BASE_URL}/master/assets/uploads/`;


    const [isLoaded, setIsLoaded] = useState(false);

    const handleClick = () => {
        if (setSelectedCard) {
            setSelectedCard(data);
        }
    };

    function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {

        if(!lat1 || !lon1 || !lat2 || !lon2){
            return 0;
        }
        const toRad = (value) => (value * Math.PI) / 180;

        const R = 6371; // Radius of the Earth in km
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;

        return distance.toFixed(2); 
    }





    return (
        <div className={`food-card ${isSelected ? "selected" : ""}`} onClick={handleClick} >
            <div className="food-image-section">
                <div className="ppc-image-wrapper">

                    {!isLoaded && (
                        <div className="ppc-skeleton ppc-shimmer"></div>
                    )}
                    {isVenueList ? (
                        <>
                            {data?.clubThumbnail && data?.clubThumbnail.length > 0 ? (
                                <img
                                    className={`food-image ${isLoaded ? 'visible' : 'hidden'}`}
                                    src={url + data?.clubThumbnail[0].img}
                                    alt={`${data?.name}`}
                                    onLoad={() => setIsLoaded(true)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultImage;
                                    }}
                                />
                            ) : (
                                <img
                                    className={`food-image ${isLoaded ? 'visible' : 'hidden'}`}
                                    src={url + (data?.profile_pic || data?.clubLogo)}
                                    alt={`${data?.name}`}
                                    onLoad={() => setIsLoaded(true)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultImage;
                                    }}
                                />
                            )}
                        </>
                    ) :
                        <img
                            src={isListingPage ? url + data?.packageThumbnail : url + data?.clubLogo}
                            alt="Live Music image"
                            className={`food-image ${isLoaded ? 'visible' : 'hidden'}`}
                            onLoad={() => setIsLoaded(true)}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultImage;
                            }}
                        />
                    }


                </div>
                    {/* <div>imsdjfhkjsdfjkadsjfhasdkjhfakjdsjadsjkadshfadshjfkjjhadfsg</div> */}

                {/* <img src={sampleImage} alt="food" className="food-image" /> */}
                {!isListingPage && !isVenueList && (<><div className="ribbon">
                    <div className='ribbon-text'>Best Offer</div>

                </div>
                    <div className="ribbon-2">
                        {data?.clubTag === "Recommended" &&
                            <div className='ribbon-text-2'>PW Recommended</div>
                        }
                    </div>




                    <div className="image-overlay">
                        {isTablebids ? (
                            <>  {data?.slab_details?.length
                                ? data.slab_details[data?.slab_details.length - 1]?.discount
                                : "N/A"}% <br />OFF</>
                        ) : (
                            <div className="bid-info">
                                <p>Bid Amount</p>
                                <p className="price">₹ {data?.price} <span className='bid-info-mrp'>{data?.mrp}</span></p>
                            </div>
                        )}

                        <div className="offer-time">
                            <p>Offer ends in</p>
                            <p className="time-left">06hr 50min</p>
                        </div>
                    </div>
                </>
                )}
                <div className="slider-dots">
                    <span className="active"></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className="food-details">
                <div className='food-name'>
                    {isVenueList ? (
                        <h3>{data?.name}</h3>
                    ) : <h3>{data?.title}</h3>}
                    <span className='f-rating'><FaRegStar />{data?.totalAverageRating}</span>
                </div>
                <div className="venue">
                    <div className='v-logo'>
                        {!isVenueList && <img src={url + data?.clubLogo} alt="venue" />}
                        {isVenueList ? (
                            <h5>Addon : {data?.addon}% | Discount : {data?.discount}%</h5>
                        ) : <h5>{data?.clubName}</h5>}

                    </div>
                    <div>
                        <span className="f-rating"><IoLocationSharp />  {data?.distance ? data?.distance : getDistanceFromLatLonInKm(latitude, longitude, data?.clubLat, data?.clubLong)} Kms</span>
                    </div>
                </div>
                <p className="address">{data?.address}</p>
                {isVenueList ? (
                    <p className="venue-type"></p>
                ) : (
                    <p className="timing">
                        Service hours: <strong>Food - 3 hours</strong> | <strong>Drinks - 1.5 hours</strong>
                    </p>
                )}

                <div className="footer-row">
                    <a href="#" className="details-link">View Details</a>
                    {isbiding && <a href="#" className=" pp-book-now-btn">Bid Now</a>}
                    {/* <a href="#" className=" pp-book-now-btn">Book Now</a> */}
                </div>
            </div>
            {data?.title === "Veg Food only" && <div className='package-veg-icon'><RiCheckboxBlankCircleFill /></div>}
        </div >
    );
};

export default PartyPackageCard;
